





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import views from "@/views/Views";

@Component<Home>({})
export default class Home extends Vue {
  get items() {
    return views;
  }
}
